// extracted by mini-css-extract-plugin
export default {"cta":"jI-z","disabled":"kI-z"};